import * as React from "react";
import styled from "styled-components";
import {routeConfig} from "../../config/language/ja-JP/presentation/route_text";
import {AppNotificationMessage,} from "../../domain/model/app_notification_message";
import PageWrapper from "../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../common/molecular/breadcrumbs/breadcrumbs";
import AppNotificationWithTexts from "../common/organism/app_notification_with_texts";
import {TBreadcrumbItem} from "../type/common";
import Assets from "../assets/img/assets";
import BtnLinkCorporateMiddle from "../common/atom/btn/btn_link_corporate_middle";


interface IProps {
}

const ClientConsultationComplete: React.FC<IProps> = (props) => {
    const [messages, setMessages] = React.useState<AppNotificationMessage[]>([]);

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        {text: `案件相談`},
    ];

    return (
        <React.Fragment>
            {messages.length > 0 && (
                <AppNotificationWithTexts
                    onClose={(id: string) =>
                        (event: any): void => {
                            setMessages([]);
                        }}
                    appNotificationMessages={messages}
                />
            )}

            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>
                <Container>
                    <Title>案件相談</Title>

                    <Message>
                        <MessageBG src={Assets.consultationMessageBG}></MessageBG>
                        <MessageIcon src={Assets.consultation02}></MessageIcon>
                        <MessageTitle>Thank you!</MessageTitle>
                        <MessageDetail>数営業日以内に担当営業よりご連絡を差し上げます。</MessageDetail>
                    </Message>

                    <div style={{display: "flex", justifyContent: "center", marginTop: "50px"}}>
                        <ButtonLink to={"/client/consultation"}>戻る</ButtonLink>
                    </div>
                </Container>
            </PageWrapper>
        </React.Fragment>
    );
};

export default ClientConsultationComplete;

const Container = styled.div`
    width: 100%;
`;

const Title = styled.div`
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 32px;
    margin-top: 40px;
`;

const Message = styled.div`
    position: relative;
    background: linear-gradient(135deg, #c3b4ff 0%, #9ec5ff 100%);
    border-radius: 24px;
    padding: 80px 40px;
    text-align: center;
    overflow: hidden;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const MessageBG = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.3;
`;

const MessageIcon = styled.img`
    position: relative;
    width: 80px;
    height: 80px;
    margin-bottom: 32px;
    z-index: 1;
`;

const MessageTitle = styled.div`
    position: relative;
    font-size: 26px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 24px;
    z-index: 1;
`;

const MessageDetail = styled.div`
    position: relative;
    font-size: 18px;
    color: #333333;
    z-index: 1;
`;

const ButtonLink = styled(BtnLinkCorporateMiddle)`
    width: 150px;
    margin-left: 20px;
    text-align: center;
`;


// WEBPACK FOOTER //
// ./src/presentation/container/client_consultation_complete.tsx